import { createSlice } from "@reduxjs/toolkit";
import { getDoctorHomeVisitRecentRequests } from "../../reducer/getDoctorHomeVisitRecent/getDoctorHomeVisitRequestsRecentReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const doctorHomeVisitRequestsRecentSlice = createSlice({
  name: "doctorHomeVisitRecentRequests",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorHomeVisitRecentRequests.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDoctorHomeVisitRecentRequests.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getDoctorHomeVisitRecentRequests.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default doctorHomeVisitRequestsRecentSlice.reducer;
